import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { cameras, matchesCamera, load, loaded } from '../cameraData';

/**
 * Composer camera picker: pick a camera for [camera=id]…[/camera], or
 * suppress linking with [nolink]…[/nolink]. Works on the current selection
 * through the editor driver (getSelectionRange/insertBetween) — the safe
 * EditorDriverInterface API, not markdown styleSelectedText.
 *
 * Gate: the button only appears in the post composer, which core already
 * restricts with discussion.editPosts.
 */
export default class CameraPickerModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.q = '';

    load().then(() => m.redraw());
  }

  className() {
    return 'CameraPickerModal Modal--large';
  }

  title() {
    return app.translator.trans('acseven-chdk-cameras.forum.picker.title');
  }

  content() {
    if (!loaded) {
      return (
        <div className="Modal-body">
          <LoadingIndicator />
        </div>
      );
    }

    const list = this.list();

    return (
      <div className="Modal-body">
        <p className="helpText">{app.translator.trans('acseven-chdk-cameras.forum.picker.help')}</p>
        <input
          className="FormControl"
          type="search"
          placeholder={app.translator.trans('acseven-chdk-cameras.forum.index.search_placeholder')}
          value={this.q}
          oninput={(e) => {
            this.q = e.target.value;
          }}
        />
        <ul className="CameraPicker-list">
          {list.slice(0, 30).map((camera) => (
            <li>
              <Button
                className="Button Button--block CameraPicker-item"
                onclick={() => this.wrap(`[camera=${camera.id}]`, '[/camera]')}
              >
                <span className="CameraPicker-name">{camera.name}</span>
                <span className="CameraPicker-id">{camera.id}</span>
              </Button>
            </li>
          ))}
        </ul>
        <Button className="Button CameraPicker-nolink" onclick={() => this.wrap('[nolink]', '[/nolink]')}>
          {app.translator.trans('acseven-chdk-cameras.forum.picker.nolink')}
        </Button>
      </div>
    );
  }

  list() {
    return cameras
      .filter((c) => matchesCamera(c, this.q))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  /**
   * Wrap the editor's current selection, or drop an empty token at the
   * cursor. BasicEditorDriver's escape parameter is unreliable in 1.x, so
   * the token is written verbatim.
   */
  wrap(startToken, endToken) {
    const editor = this.attrs.editor;
    const [start, end] = editor.getSelectionRange();
    const selected = editor.el.value.slice(start, end);
    const text = startToken + selected + endToken;

    editor.insertBetween(start, end, text);
    this.hide();
  }
}
